import { render, staticRenderFns } from "./Terminology.vue?vue&type=template&id=1f519b4f&scoped=true"
import script from "./Terminology.vue?vue&type=script&lang=js"
export * from "./Terminology.vue?vue&type=script&lang=js"
import style0 from "./Terminology.vue?vue&type=style&index=0&id=1f519b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f519b4f",
  null
  
)

export default component.exports